import React, { useState } from "react";
import styled from "styled-components";

// =======================
// Layout & Base Styles
// =======================
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 70px 30px;  
`;

const Jumbotron = styled.section`
  position: relative;
  background: linear-gradient(
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.6)
    ),
    url('/assets/company/office-bg.jpg') center/cover no-repeat;
  color: white;
  border-radius: 16px;
  text-align: center;
  padding: 100px 30px;
  margin-bottom: 60px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

  h1 {
    font-size: 3rem;
    color: #f29f02;
    margin-bottom: 20px;
  }

  p {
    font-size: 1.2rem;
    max-width: 700px;
    margin: 0 auto;
    color: #fff;
    line-height: 1.6;
  }
`;

const Section = styled.div`
  margin-bottom: 20px;
  border: 1px solid #eee;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
`;

const SectionHeader = styled.div`
  background: #f9f9f9;
  color: #333;
  font-weight: bold;
  font-size: 1.2rem;
  padding: 15px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background: #fef6e7;
  }
`;

const Icon = styled.span`
  font-size: 1.5rem;
  color: #f29f02;
  transform: ${(props) => (props.expanded ? "rotate(90deg)" : "rotate(0deg)")};
  transition: transform 0.2s ease-in-out;
`;

const SectionContent = styled.div`
  max-height: ${(props) => (props.expanded ? "500px" : "0")};
  overflow: scroll;
  transition: max-height 0.4s ease;
  background: #fff;
  padding: ${(props) => (props.expanded ? "20px" : "0 20px")};
  color: #444;
  line-height: 1.6;
`;

// =======================
// Info & Footer
// =======================
const InfoSection = styled.section`
  text-align: left;
  margin-top: 60px;
  margin-bottom: 200px;
`;

const InfoTitle = styled.h2`
  color: #f29f02;
  font-size: 24px;
  margin-bottom: 20px;
`;

const InfoText = styled.p`
  font-size: 1rem;
  margin: 5px 0;
`;

const CountryList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const CountryItem = styled.li`
  font-size: 1rem;
  margin-bottom: 5px;
  float: left;
`;

const BottomImage = styled.img`
  display: block;
  margin: 0 auto;
  max-width: 100%;
  max-height: 200px;
  height: auto;
`;



// =======================
// Component
// =======================
const Company = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (index) => {
    setOpenSection(openSection === index ? null : index);
  };

  const sections = [
    {
      title: "Profile & Infrastructure",
      content:
        "PT. L-HIJRAH was established on January 2012, before was built with different name on 2008 by the same founder. In 2018, management team form the alliance corporate & legalize them in Hijrah Group as Association, then formulated the idea of a multifunctional network called L’Network with several business club",
        ul: [],
      ol: [],
    },
    {
      title: "Vision",
      content:
        `Our corporate line operate on a high level scale quality and performance of Apps Products, as our vision for fixed destiny and based on valuable principle to make eficiency system digital online in future orientation and expression newest creativity for computer program, so our vision can be as below`,
        ul: [],
      ol: [
        'Make an easy access for all job description by mobile apps',
        'Network expansion in every town, provinces, and remote area',
        'Facilitate & support all user registered',
      ]
    },
    {
      title: "Mission",
      content:
        `To realize the vision above, our company take a run the best strategy with a few of steps that can be changed conditionally follow the necessity, so we arrange to make execution as below`,
        ul: [],
      ol: [
        'Provide all moduls (services, products & financial technology)',
        'H2H merchant with all provider (courier group, local bank & shops)',
        'Compatibility price, so simple to be reached of any community',
        'Update & Evaluation system every month',
      ]
    },
    {
      title: "Legal & Alliances",
      content : null,
      ul: [],
      ol: [
        'PT. L-HIJRAH (APW & BPW) — Technology Development & Tourism (Since 2012)',
        'YAYASAN L-HIJRAH — Education & Social Foundation (Since 2015)',
        'KOPERASI SYARIAH L-HIJRAH — Sharia Cooperative (Since 2015)',
        'HIJRAH GROUP, Permit in General Association (Since 2019)',
      ],
    },
    {
      title: "Our Clients",
      content: null,
      ol: [],
      ul: [
        
        "Premiere Engineering & Development Sdn. Bhd.",
        "Dar At-Tawafuq, Oman.",
        "Marifa Academy, United Arab Emirates.",
        "College University Bestari",
        "Kolej Al Ihsaniah, etc...",
        null,
        
        "FISIP Universitas Sumatera Utara",
        "PELINDO -  IT Support",
        "PPSU Booking System - IT Support",
        "Satu Data Indonesia - IT Support, etc...",
      ]
    },
  ];

  return (
    <Container>
      <Jumbotron>
        <h1>Welcome to Hijrah Group</h1>
        <p>
          Empowering innovation through technology — building sustainable
          digital solutions across nations with excellence and integrity.
        </p>
      </Jumbotron>

      {/* 🧱 Expand/Collapse Sections */}
      {sections.map((section, index) => (
        <Section key={index}>
          <SectionHeader onClick={() => toggleSection(index)}>
            {section.title}
            <Icon expanded={openSection === index}>
              {openSection === index ? "▶" : "►"}
            </Icon>
          </SectionHeader>
          <SectionContent expanded={openSection === index}>
            <p style={{ textAlign: "justify" }}>
              {section.content}
            </p>

            <ol
              style={{
                listStyleType: "decimal",
                listStylePosition: "outside",
                paddingInlineStart: "20px", // sejajarkan dengan teks paragraf
                marginTop: "8px"
              }}
            >
              {section?.ol.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ol>

            <ul
              style={{
                listStyle: "none",
                paddingInlineStart: "20px",
                marginTop: "8px",
              }}
            >
              {section?.ul.map((item, i) => (
                <>
                <b>
                  {i == 0 ? "Foreign Clients" : ""}
                  {i == 6 ? "Domestic Clients" : ""}
                </b>
                <li
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "8px",
                    marginBottom: "6px",
                  }}
                >
                  
                  <span>{item != null ? "✅": ""}</span>                  
                  <span>{item || "\u00A0"}</span>
                </li>
                </>
              ))}
            </ul>

          </SectionContent>
        </Section>
      ))}

      {/* 🌍 Info Section */}
      <InfoSection>
        <InfoTitle>Contact & Global Presence</InfoTitle>
        <InfoText style={{
          fontWeight: 'bold'
        }}>HIJRAH GROUP (Indonesia HQ)</InfoText>
        <InfoText>Registrasi No. 6019090712100478</InfoText>
        <hr/>
        <br/>
        <InfoText style={{
          fontWeight: 'bold'
        }}>HANA MANIS SDN.BHD (Malaysia HQ)</InfoText>
        <InfoText>Registrasi No. 0658545P / 200401020041</InfoText>
        <hr/>
        <br/>
        <InfoText>📞 Mobile Phone:<br/>
          <a href="tel:+601116385226" className="text-yellow-900">+60 111 638 5226</a>
        </InfoText>
        <InfoText>📞 WhatsApp Hot Line:<br/>           
          <a href="tel:+6281717141717" className="text-yellow-900">+628 1717 14 1717</a>
          </InfoText>
        <InfoText>📞 Office Call Centre:<br/>           
          <a href="tel:+60362532460" className="text-yellow-900">+603 6253 2460</a>
        </InfoText>
        <hr/>
        <InfoText>✉️ Email Official:<br/>
          <a href="mailto:marketingclub.network@gmail.com">marketingclub.network@gmail.com</a>
        </InfoText>
        <br />
        <InfoTitle>🌍 Operating Countries</InfoTitle>
        <CountryList>
          <CountryItem>🇮🇩 Indonesia&nbsp;-&nbsp;</CountryItem>
          <CountryItem>🇲🇾 Malaysia&nbsp;-&nbsp;</CountryItem>
          <CountryItem>🇸🇬 Singapore&nbsp;-&nbsp;</CountryItem>
          <CountryItem>🇲🇦 Morocco&nbsp;-&nbsp;</CountryItem>
          <CountryItem>🇧🇳 Brunei</CountryItem>
        </CountryList>
      </InfoSection>

      {/* 🏙️ Footer Image */}
      <BottomImage
        src="/assets/company/city-sketch-2.png"
        alt="Company Footer"
      />
    </Container>
  );
};

export default Company;


// import styled from 'styled-components';

// const Container = styled.div`
//     max-width: 1200px;
//     margin: 0 auto;
//     padding: 70px 30px;
// `;

// const Header = styled.header`
//     text-align: center;
//     margin-bottom: 40px;
// `;

// const Title = styled.h1`
//     color: #f29f02;
//     font-size: 2.5rem;
// `;

// const Description = styled.p`
//     font-size: 1.2rem;
// `;

// // position: fixed;
// //   bottom: 0;
// //   left: 50%;
// //   z-index: 2;
// // transform: translateX(-50%);
  
// const BottomImage = styled.img`
//   max-width: 100%;
//   max-height: 200px;
//   height: auto;
// `;

// const InfoSection = styled.section`
//   text-align: left;
//   margin-top: 60px;  
//   margin-bottom: 200px;
// `;

// const InfoTitle = styled.h2`
//   color: #f29f02;
//   font-size: 2rem;
//   margin-bottom: 20px;
// `;

// const InfoText = styled.p`
//   font-size: 1rem;
//   margin: 5px 0;
// `;

// const CountryList = styled.ul`
//   list-style-type: none;
//   padding: 0;
// `;

// const CountryItem = styled.li`
//   font-size: 1rem;
//   margin-bottom: 5px;
//   float:left
// `;

// const Company = () => {

//   return (
//     <Container>
//       <Header>
//         <Title>Our Company</Title>
//         <br />
//         <Description>
//           This company offers innovative, problem-solving solutions that empower you to concentrate on what truly matters—creating and growing your business. Our services eliminate unnecessary complexities, allowing you to focus entirely on innovation, development, and making a real impact in your industry.
//         </Description>        
//       </Header>
//       <InfoSection>
//         <InfoTitle>Contact & Global Presence</InfoTitle>
//         <InfoText>📞 Phone: +60 111 638 5226</InfoText>
//         {/* <InfoText>📍 Virtual Office: Jl. Teknologi No. 88, Medan, Indonesia</InfoText> */}
//         <br />
//         <InfoTitle>🌍 Operating Countries</InfoTitle>
//         <CountryList>
//           <CountryItem>🇮🇩 Indonesia&nbsp;-&nbsp;</CountryItem>
//           <CountryItem>🇲🇾 Malaysia&nbsp;-&nbsp;</CountryItem>
//           <CountryItem>🇸🇬 Singapore&nbsp;-&nbsp;</CountryItem>
//           <CountryItem>🇲🇦 Morocco&nbsp;-&nbsp;</CountryItem>
//           <CountryItem>🇧🇳 Brunei</CountryItem>
//         </CountryList>
//       </InfoSection>

//       <BottomImage src="/assets/company/city-sketch-2.png" alt="Company Footer" />
//     </Container>
//   );
// };

// export default Company;
